<template>
	<BaseContenedor>
		<div class="ui very padded segment">
			<sui-form @submit.prevent>
				<sui-header dividing>Plantel</sui-header>
				<div class="ui grid">
					<div class="twelve wide column">
						<div class="field">
							<label>Identificador</label>
							<input
								:value="getPlantel"
								type="text"
								disabled
								placeholder="Identificador plantel"
							/>
						</div>
						<div class="field">
							<label>Nombre plantel</label>
							<input
								:value="getNombrePlantel"
								type="text"
								disabled
								placeholder="Nombre plantel"
							/>
						</div>
					</div>
					<div class="four wide column">
						<img class="ui medium  image" :src="getLogoPlantel" />
					</div>
				</div>
				<sui-header dividing
					>Configuración de fullscreen y grabación</sui-header
				>
				<div class="ui segment">
					<sui-form-field>
						<sui-checkbox
							:value="getEnableFullScreen"
							toggle
							disabled
							label="Establece el sistema que se active automaticamente el fullscreen al aspirante"
						/>
					</sui-form-field>
				</div>
				<div class="ui segment">
					<sui-form-field>
						<sui-checkbox
							:value="getEnableScreenRecorder"
							toggle
							disabled
							label="Establece el sistema que necesite grabar la pantalla del aspirante"
						/>
					</sui-form-field>
				</div>
				<div class="ui segment">
					<sui-form-field>
						<sui-checkbox
							:value="getEnableCameraRecorder"
							toggle
							disabled
							label="Establece el sistema que necesite grabar con la camara al aspirante"
						/>
					</sui-form-field>
				</div>
				<br />
				<sui-header dividing>Hora</sui-header>
				<sui-form-field>
					<label>Zona horaria</label>
					<sui-dropdown
						:value="getZonaHoraria"
						placeholder="Seleccione una zona horaria"
						selection
						disabled
						:options="zonasHorarias"
					/>
				</sui-form-field>
			</sui-form>
		</div>
	</BaseContenedor>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import ZonasHorarias from '@constants/zonasHorarias';

export default {
	page: {
		title: 'Configuración de carga',
		meta: [{ name: 'Carga', content: 'Configuración de carga' }]
	},
	data: function() {
		return {
			plantel: '',
			nombrePlantel: '',
			fullScreen: false,
			screenRecorder: false,
			cameraRecorder: false,
			zonaHoraria: null,
			configDate: {
				dateFormat: 'Y-m-d'
			},
			configTime: {
				enableTime: true,
				noCalendar: true,
				dateFormat: 'H:i',
				time_24hr: true
			},
			departamentos: []
		};
	},
	computed: {
		...mapGetters('configuraciones', [
			'getLoading',
			'getEnableFullScreen',
			'getEnableScreenRecorder',
			'getEnableCameraRecorder',
			'getLogoPlantel',
			'getNombrePlantel',
			'getPlantel',
			'getZonaHoraria'
		]),
		zonasHorarias: function() {
			return ZonasHorarias.map((zonaHoraria) => ({
				value: zonaHoraria.clave,
				text: `${zonaHoraria.clave} ${zonaHoraria.descripcion}`
			}));
		}
	},
	watch: {},
	mounted() {
		this.establecerTitulo('Configuraciónes generales');
		this.establecerUrlAtras('/inicio');
		this.obtener();
	},
	methods: {
		...mapActions('app', ['establecerTitulo', 'establecerUrlAtras']),
		...mapActions('configuraciones', ['obtener', 'editar'])
	}
};
</script>

<style lang="scss" module>
@import '@design';
</style>
